import React from 'react';
import { useReducedMotion } from 'framer-motion';
import { TICKER_ITEMS } from '../data/tickerItems';

export default function FooterTickerRail() {
  const reduceMotion = useReducedMotion();
  const track = [...TICKER_ITEMS, ...TICKER_ITEMS];

  return (
    <div className="ticker-rail ticker-rail--footer" aria-hidden="true">
      <div className="ticker-rail__mask">
        <div className={`ticker-rail__track${reduceMotion ? ' ticker-rail__track--static' : ''}`}>
          {track.map((item, i) => (
            <div key={`${item.label}-${i}`} className="ticker-card" data-accent={item.accent}>
              <span className="ticker-card__shine" aria-hidden="true" />
              <span className="ticker-card__text">{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
